import { useEffect } from "react";

/**
 * Lightweight SEO/AEO head manager — no external dep.
 * Updates document title, meta description, canonical, og tags, and JSON-LD.
 */
export default function SEO({ title, description, image, path, jsonLd }) {
    useEffect(() => {
        if (title) document.title = title;

        const setMeta = (selector, attr, key, value) => {
            if (!value) return;
            let el = document.head.querySelector(selector);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, key);
                document.head.appendChild(el);
            }
            el.setAttribute("content", value);
        };

        setMeta('meta[name="description"]', "name", "description", description);
        setMeta('meta[property="og:title"]', "property", "og:title", title);
        setMeta('meta[property="og:description"]', "property", "og:description", description);
        setMeta('meta[property="og:image"]', "property", "og:image", image);
        setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
        setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
        setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

        // canonical
        if (path) {
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", `https://cakecentral.com.au${path}`);
        }

        // JSON-LD
        const existing = document.head.querySelectorAll('script[data-dynamic-jsonld="true"]');
        existing.forEach((s) => s.remove());
        if (jsonLd) {
            const script = document.createElement("script");
            script.type = "application/ld+json";
            script.dataset.dynamicJsonld = "true";
            script.text = JSON.stringify(jsonLd);
            document.head.appendChild(script);
        }
    }, [title, description, image, path, jsonLd]);

    return null;
}
